import type {PermissionsRecordType} from '../permissions';

export const serviceAccountPermissions = {
  readServiceAccount: {
    actionId: 'READ',
    resourceId: 'SERVICE_ACCOUNT',
    scopes: [],
  },
  createServiceAccount: {
    actionId: 'CREATE',
    resourceId: 'SERVICE_ACCOUNT',
    scopes: [],
  },
  updateServiceAccount: {
    actionId: 'UPDATE',
    resourceId: 'SERVICE_ACCOUNT',
    scopes: [],
  },
  activateServiceAccount: {
    actionId: 'ACTIVATE',
    resourceId: 'SERVICE_ACCOUNT',
    scopes: [],
  },
  deactivateServiceAccount: {
    actionId: 'DEACTIVATE',
    resourceId: 'SERVICE_ACCOUNT',
    scopes: [],
  },
  deleteServiceAccount: {
    actionId: 'DELETE',
    resourceId: 'SERVICE_ACCOUNT',
    scopes: [],
  },
  rotateServiceAccountKey: {
    actionId: 'ROTATE_KEY',
    resourceId: 'SERVICE_ACCOUNT',
    scopes: [],
  },
  revokeServiceAccountKey: {
    actionId: 'REVOKE_KEY',
    resourceId: 'SERVICE_ACCOUNT',
    scopes: [],
  },
} satisfies PermissionsRecordType;
